import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { AranLoadingService } from '@aran-client/aran-web-ui-toolkit';

export const BYPASS_LOADER = new HttpContextToken(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  constructor(private aranLoadingService: AranLoadingService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.url.endsWith('.json') || req.context.get(BYPASS_LOADER)) {
      return next.handle(req);
    }

    this.aranLoadingService.show();

    this.activeRequests++;
    this.aranLoadingService.show();

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.aranLoadingService.hide();
        }
      })
    );
  }
}
